import { ReactNode, SVGAttributes } from 'react';
import clsx from 'clsx';

type Size = 'small' | 'medium' | 'large';
type Color = 'primary' | 'secondary' | 'default';

// eslint-disable-next-line @typescript-eslint/ban-types
export type IconProps = {
  children?: ReactNode;
  size?: Size;
  color?: Color;
  useStroke?: boolean;
} & SVGAttributes<HTMLOrSVGElement>;

// icon variants
const SIZE_MAPS: Record<Size, string> = {
  small: `h-4 w-4`,
  medium: `h-6 w-6`,
  large: `h-8 w-8`,
};

const COLOR_MAPS: Record<Color, string> = {
  primary: `text-green-600`,
  secondary: `text-purple-600`,
  default: `text-[inherit]`,
};

/**
 * @component Icon
 */
function Icon({
  children,
  color = `default`,
  size = `medium`,
  className,
  useStroke,
  ...rest
}: IconProps) {
  const classes = clsx(
    `fill-current`,
    { 'stroke-current': useStroke },
    SIZE_MAPS[size],
    COLOR_MAPS[color],
    className,
  );
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={classes}
      {...rest}
    >
      {children}
    </svg>
  );
}

export default Icon;
